const theme = {
  colors: {
    primary: '#FFC0CB', // Baby Pink
    primaryDark: '#FF69B4', // Dark Pink
    secondary: '#FF1493', // Deep Pink
    accent: '#FF69B4', // Hot Pink
    dark: '#333333',
    light: '#FFF0F5', // Lavender Blush
    white: '#FFFFFF',
    black: '#000000',
    gray: '#CCCCCC',
    error: '#FF0000',
    success: '#28A745',
    warning: '#FFC107',
    info: '#17A2B8',
  },
  fonts: {
    main: "'Playfair Display', serif",
    secondary: "'Montserrat', sans-serif",
  },
  fontSizes: {
    small: '0.875rem',
    medium: '1rem',
    large: '1.25rem',
    xlarge: '1.5rem',
    xxlarge: '2rem',
    xxxlarge: '3rem',
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    laptop: '992px',
    desktop: '1200px',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.1)',
    large: '0 8px 16px rgba(0, 0, 0, 0.1)',
  },
  transitions: {
    short: 'all 0.2s ease-in-out',
    medium: 'all 0.3s ease-in-out',
    long: 'all 0.5s ease-in-out',
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
    round: '50%',
  },
};

export default theme;
